import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import OrganizationList from "./OrganizationList";
import OrganizationCreate from "./OrganizationCreate";
import OrganizationEdit from "./OrganizationEdit";
import { RoleEnum } from "../../types/RoleEnum";
import { RouteGuard } from "../../guards/RouteGuard";
function Organization() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return React.createElement(OrganizationList, null); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(OrganizationCreate, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(OrganizationEdit, null))); } })));
}
export default Organization;
